import AuthenticationContext from 'adal-angular';
import { inject, injectable } from 'inversify';
import { ConfigService } from './ConfigService';
import axios from 'axios';
import { TYPES } from '@/app/types';
import { User } from '@/models/context/User';

// Later - get configservice to ask inversify for an http service
@injectable()
export class SecurityService {
  private authOptions: AuthenticationContext.Options;
  private authenticationContext: AuthenticationContext;
  private user!: User;

  constructor(@inject(TYPES.Services.ConfigService) private configService: ConfigService) {
    this.authOptions = this.LoadAuthOptions();
    this.authenticationContext = new AuthenticationContext(this.authOptions);
  }

  public get User(): User {
    return this.user;
  }

  public Initialise() {
    // Check For & Handle Redirect From AAD After Login
    if (this.authenticationContext.isCallback(window.location.hash)) {
      this.authenticationContext.handleWindowCallback();
    }

    // Check for a user object
    const user = this.authenticationContext.getCachedUser();
    if (user) {
      this.ConfigureAxios();
      this.user = User.LoadFromAdalUser(user);
      // this.OnLogin(null, this.user);
    } else {
      // No user found, so initiate login
      this.authenticationContext.login();
    }
  }

  public GetToken(): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      this.authenticationContext.acquireToken(this.authOptions.clientId, (error, token) => {
        if (error) {
          // Acquire token failure
          if (this.authOptions.popUp) {
            // If using popup flows
            this.authenticationContext.acquireTokenPopup(this.authOptions.clientId, null, null, (errorDesc, token, error) => { });
          } else {
            // In this case the callback passed in the Authentication request constructor will be called.
            this.authenticationContext.acquireTokenRedirect(this.authOptions.clientId, null, null);
          }
        } else {
          // Acquired token successfully
          resolve(token as string);
        }
      });
    });
  }

  public Logout() {
    this.authenticationContext.logOut();
  }

  private LoadAuthOptions(): AuthenticationContext.Options {
    return {
      instance: this.configService.Config.AzureAdInstance,
      tenant: this.configService.Config.AzureAdTenant,
      clientId: this.configService.Config.AzureAdClientId,
      postLogoutRedirectUri: window.location.origin,
      popUp: false,
      callback: this.AuthenticationCallback,
      // cacheLocation: 'localStorage',
    } as AuthenticationContext.Options;
  }

  private ConfigureAxios() {
    // Add an interceptor that inserts the user token
    axios.interceptors.request.use(async (config) => {
      const token = await this.GetToken();
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    });
  }

  private AuthenticationCallback(errorDesc: string | null, token: string | null, error: any, tokenType: any) {
  }

  public UserHasRole(roleName: string) {
    return this.user.HasRole(roleName);
  }
}